import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=31b0195b&scoped=true&"
import script from "./PlanDetail.vue?vue&type=script&lang=js&"
export * from "./PlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=31b0195b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0195b",
  null
  
)

export default component.exports